import styled from "styled-components";

import {
  container,
  cardTitle,
  whiteColor,
  grayColor,
  infoColor,
} from "assets/jss/material-dashboard-pro-react.js";

// List
export const MenuMini = styled.div`
  position: absolute;
  top: 150px;
  left: 0;
  z-index: 10000;
  width: 80px;
  height: 50px;
  display: flex;
  align-items: center;
  background-color: ${infoColor[0]};
  border-radius: 0 30px 30px 0;
  box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.42);
`;

export const CardTitleStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const ListStyled = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  overflow: auto;
`;
export const ListItemStyled = styled.li`
  display: flex;
  border-bottom: 1px solid #eeeeee;
`;
export const ListItemHeaderStyled = styled.div`
  display: flex;
  justify-content: ${(props) =>
    props.position ? `${props.position}` : "center"};
  align-items: center;
  font-size: 12px;
  width: 100%;
  margin-bottom: 0.4rem;
`;
export const TitleContainerStyled = styled.div`
  margin: 0 0.2rem;
`;
export const ListItemTitleStyled = styled.h6`
  display: flex;
  /* background-color: greenyellow; */
  color: ${(props) => (props.color ? `${props.color}` : "#9c27b0")};
  margin: 0;
  margin-bottom: 0.3rem;
`;
export const LineStyled = styled.hr`
  width: 100%;
  border: 0;
  height: 1px;
  margin: 0.2rem 0;
  background-image: linear-gradient(
    to right,
    rgba(196, 196, 196, 0.1),
    rgba(196, 196, 196, 0.75),
    rgba(196, 196, 196, 0.1)
  );
`;
export const QuantityStyled = styled.span`
  margin-left: 0.2rem;
`;
export const CheckboxContainerstyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ColumnStyled = styled.div`
  padding: 3px;
  text-align: center;

  flex-direction: ${(props) => (props.dir ? `${props.dir}` : "row")};
  justify-content: ${(props) =>
    props.position ? `${props.position}` : "center"};
  font-size: 12px;
  /* width: 25%; */
  width: ${(props) => (props.width ? `${props.width}%` : "10%")};
  word-wrap: break-all;
  display: flex;
  align-items: center;
  color: #3c4858;
`;

export const styles = (theme) => ({
  container: {
    ...container,
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "100px",
    },
  },
  cardTitle: {
    ...cardTitle,
    color: whiteColor,
  },
  textCenter: {
    textAlign: "center",
  },
  justifyContentCenter: {
    justifyContent: "center !important",
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: whiteColor,
    },
    marginLeft: "5px",
    marginRight: "5px",
  },
  inputAdornment: {
    marginRight: "18px",
  },
  inputAdornmentIcon: {
    color: grayColor[6],
  },
  cardHidden: {
    opacity: "0",
    // transform: "translate3d(0, -60px, 0)",
    transform: "translateX(-100%)",
    transitionDuration: "500ms",
  },

  cardOpen: {
    opacity: "1",
    transform: "translateX(0)",
    transitionDuration: "500ms",
  },
  cardHeader: {
    marginBottom: "20px",
  },
  socialLine: {
    padding: "0.9375rem 0",
  },
  cardMapLeft: {
    position: "absolute",
    top: "2%",
    left: "0",
    // transform: "translateY(-20%)",
    zIndex: "9999",
    marginLeft: "1rem",
    width: "350px",
    height: "90vh",
  },
  cardBody: {
    paddingLeft: "0.3rem",
    paddingRight: "0.3rem",
  },
  mapLateralCloseButtonLeft: {
    position: "absolute",
    margin: "0",
    top: "0",
    left: "0",
    zIndex: "1080",
    transform: "translate(-50%, -50%)",
  },
  mapLateralCloseButtonRight: {
    position: "absolute",
    margin: "0",
    top: "0",
    right: "0",
    zIndex: "1080",
    transform: "translate(50%, -50%)",
  },
  menuIcon: {
    width: "40px",
    height: "40px",
    marginLeft: "30px",
    color: whiteColor,
  },
});
